var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import FavouriteButton from "../../Favourite/ButtonWithIcon";
export default styled(FavouriteButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: ", " 0 0 0;\n    display: none;\n    ", "\n  "], ["\n    margin: ", " 0 0 0;\n    display: none;\n    ",
        "\n  "])), theme.spacing.two, theme.mediaQueries.minWidthMedia.desktop(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: block;\n      margin: 0 auto;\n    "], ["\n      display: block;\n      margin: 0 auto;\n    "]))));
});
var templateObject_1, templateObject_2, templateObject_3;
